import {fabric} from 'fabric';
import React, {useCallback, useContext, useEffect, useState} from 'react';
import {EventCreateContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/EventCreateContext';
import {Range} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/components/Range/Range';
import {detectPinchGesture} from '~/CreateFabricInvitation/utils/detectPinchGesture';
import {useImageResizeListener} from './hooks/useImageSize';
import './ImageSize.sass';

const MIN_IMAGE_SIZE = 0.1;
const MAX_IMAGE_SIZE = 2;

export const ImageSize = () => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const [value, setValue] = useState(1);

  useImageResizeListener(canvas);

  useEffect(() => {
    if (!canvas) return;

    let scale = 1;
    if (activeObjects?.length) {
      if (Array.isArray(activeObjects) && activeObjects.length > 0) {
        const [uyoImg] = activeObjects;
        const originalScale = fabric.util.findScaleToCover(uyoImg, uyoImg._originalObject);
        if (uyoImg) {
          scale = (uyoImg.scaleX / originalScale).toFixed(1);
          if (scale) {
            setValue(scale);
          }
        }
      }
    }

    const handleObjectModified = () => {
      if (activeObjects?.length) {
        const [uyoImg] = activeObjects;
        if (uyoImg) {
          const originalScale = fabric.util.findScaleToCover(uyoImg, uyoImg._originalObject);
          const newScale = (uyoImg.scaleX / originalScale).toFixed(1);
          setValue(newScale);
        }
      }
    };

    canvas.on('object:modified', handleObjectModified);

    const cleanup = detectPinchGesture((scaleFactor) => {
      setValue(scaleFactor);
    }, scale);

    // eslint-disable-next-line consistent-return
    return () => {
      cleanup();
      canvas.off('object:modified', handleObjectModified);
    };
  }, [activeObjects, canvas]);

  const setNewValue = useCallback(
    (newValue) => {
      setValue(newValue);

      let uyoImage;
      if (Array.isArray(activeObjects) && activeObjects.length > 0) {
        [uyoImage] = activeObjects;

        const scale = fabric.util.findScaleToCover(uyoImage, uyoImage._originalObject);
        const newScale = scale * Number(newValue);
        uyoImage.scale(newScale);

        canvas.requestRenderAll();
        canvas.fire('object:modified');
      }
    },
    [canvas, activeObjects]
  );

  return (
    <div className="create-flow__range textsize">
      <Range
        min={MIN_IMAGE_SIZE}
        max={MAX_IMAGE_SIZE}
        step="0.1"
        value={value}
        onChange={setNewValue}
        onLocalChange={setNewValue}
        hasControls
        hiddenInput
      />
    </div>
  );
};
